import { createRoot } from 'react-dom/client';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import RankingScreen from './containers/RankingScreen';
import FavoritosScreen from './containers/FavoritosScreen';
import FavoritoSearchScreen from './containers/FavoritoSearchScreen';
import EventoListScreen from './containers/EventoListScreen';
import EventoDetailScreen from './containers/EventoDetailScreen';
import CompeticionScreen from './containers/CompeticionScreen';
import ResultadoScreen from './containers/ResultadoScreen';
import TodosScreen from './containers/TodosScreen';
import MsgNetError from './components/MsgNetError';
import LocationListScreen from './containers/LocationListScreen';
import LocationDetailScreen from './containers/LocationDetailScreen';
import CompeticionGps from './containers/CompeticionGps';
import ScrapeableScreen from './containers/ScrapeableScreen';
import * as serviceWorker from './registerServiceWorker';
import './tailwind.css';

// Google Analytics
window['GoogleAnalyticsObject'] = 'ga';
window['ga'] = window['ga'] || function () {
  (window['ga'].q = window['ga'].q || []).push(arguments);
};

export const trackPageView = (pathname, search = '') => {
  if (typeof window.ga === 'function') {
    window.ga('set', 'page', pathname + search);
    window.ga('send', 'pageview');
  }
};

const root = createRoot(document.getElementById('root'));
root.render(
  <div className="min-h-screen bg-gray-900 text-gray-100">
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <Routes>
        <Route path='/' element={<EventoListScreen />} />
        <Route path='/:eventoId' element={<EventoDetailScreen />} />
        <Route path='/:eventoId/locations' element={<LocationListScreen />} />
        <Route path='/:eventoId/location/:locationId' element={<LocationDetailScreen />} />
        <Route path='/competicion/:competicionId' element={<CompeticionScreen />} />
        <Route path='/competicion/:competicionId/favoritos' element={<FavoritosScreen />} />
        <Route path='/competicion/:competicionId/gps' element={<CompeticionGps />} />
        <Route path='/competicion/:competicionId/ranking' element={<RankingScreen />} />
        <Route path='/competicion/:competicionId/ranking/:rankingId' element={<RankingScreen />} />
        <Route path='/competicion/:competicionId/buscar' element={<FavoritoSearchScreen />} />
        <Route path='/competicion/:competicionId/dorsal/:dorsal' element={<ResultadoScreen />} />
        <Route path='/competicion/:competicionId/todos' element={<TodosScreen />} />
        <Route path='/competicion/:competicionId/control/:controlId' element={<CompeticionScreen />} />
        <Route path="/scrap/competicion/:competicionId" element={<ScrapeableScreen />} />
        <Route path='*' element={<MsgNetError />} />
      </Routes>
    </BrowserRouter>
  </div>
);

serviceWorker.default();
